module.exports = __webpack_public_path__ + "d8bc713f33da2b0dc1fd13f9cda2f669.png";